export enum NodeRole {
    DEVELOPER = "DEVELOPER",
    CONTRACTOR = "CONTRACTOR",
}
